import { Controller } from 'stimulus';

// The Task Comments window's box (task_comments/_index): Enter starts a new
// line, and Ctrl+Enter (Cmd+Enter on a Mac) adds the comment, as Add Comment
// does. Clicking the button keeps rails-ujs's remote submit and disable_with.
export default class extends Controller {
  static targets = ['button'];

  submitOnCtrlEnter(event) {
    if (event.key !== 'Enter' || !(event.ctrlKey || event.metaKey)) return;

    event.preventDefault();
    if (!this.buttonTarget.disabled) this.buttonTarget.click();
  }
}
